export default __webpack_public_path__ + "static/media/tree-num-two.1404d12c.png";